import * as Joi from 'joi';
import { CandidateBlacklistFormData } from '../../../models';
import { getNricFinJoiObject } from '../../../utils/JoiUtils';

const schemaAddCandidateBlacklist = Joi.object<CandidateBlacklistFormData>({
  name: Joi.string().required().max(66).messages({
    'string.empty': 'Name is not allowed to be empty',
    'string.max': 'Name is too long',
  }),
  uinfinOrPassport: getNricFinJoiObject(),
  dateOfBirth: Joi.string().required().messages({
    'any.required': 'Date of birth is not allowed to be empty',
  }),
  IdType: Joi.string().required(),
  examType: Joi.string().required().messages({
    'any.required': 'Please select exam type',
  }),
});

export default schemaAddCandidateBlacklist;
